// extracted by mini-css-extract-plugin
export default {"postcodeModal":"FpgzC4X1yN","text1":"A5FWH3FSLD","text2":"XfaHug6l68","postcodeTextField":"ZitAkIF0PA","showPriceButton":"ERRj82c7S0","searchIcon":"dE6wIp6nzq"};